import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("wms_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !e.config.url.includes("/auth/login")) {
      localStorage.removeItem("wms_token");
      window.dispatchEvent(new Event("wms-logout"));
    }
    return Promise.reject(e);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Terjadi kesalahan / 发生错误";
  if (typeof d === "string") return d.includes("|") ? d.split("|").slice(1).join("|") : d;
  if (Array.isArray(d)) return d.map((x) => `${(x.loc || []).slice(-1)[0]}: ${x.msg}`).join("; ");
  return String(d);
}

export const newRequestId = (p) => `${p}-${Date.now()}-${Math.random().toString(36).slice(2, 8).toUpperCase()}`;

export const fmt = (n, d) => { const v = Number(n || 0); const dd = d === undefined ? (Math.abs(v) >= 100 || Number.isInteger(v) ? 0 : 2) : d; return v.toLocaleString("id-ID", { maximumFractionDigits: dd }); };

export const todayJkt = () => new Date(Date.now() + 7 * 3600 * 1000).toISOString().slice(0, 10);

export async function download(path, params, filename) {
  const r = await api.get(path, { params, responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export const NO_ROLE_HINT = "Tidak memiliki akses / 无权限";
